export const WEBSOCKET_TIMEOUT_MINUTES = 10;
